import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable, Subject} from "rxjs";

@Injectable()
export class GlobalSpinnerTriggeringService {

	private trigger$: Subject<boolean> = new BehaviorSubject(false);

	setVisible(visible: boolean): void {
		this.trigger$.next(visible);
	}

	getObservable(): Observable<boolean> {
		return this.trigger$.asObservable();
	}
}
